import React, { ReactNode } from 'react';

import { ErrorLayout } from './components';
import { SIZE } from '../../assets/styles';

interface IState {
  hasError: boolean;
  isMobile: boolean;
}
type MyProps = {
  Wrapper: (children: ReactNode) => ReactNode;
  children: ReactNode;
};

export class ErrorBoundary extends React.Component<MyProps, IState> {
  constructor(props: MyProps) {
    super(props);
    this.state = {
      hasError: false,
      isMobile: window.innerWidth < SIZE.laptop,
    };
  }

  componentDidCatch(_: Error) {
    this.setState({ hasError: true });
  }

  render() {
    if (this.state.hasError) {
      return this.props.Wrapper(<ErrorLayout />);
    }

    return this.props.children;
  }
}
